const useLogOut = () => async () => {
  localStorage.removeItem("okta-token-storage");
  sessionStorage.removeItem("logout_initiated");
  window.location.assign(OVERVIEW_REDIRECT_TARGET);
};

const OVERVIEW_REDIRECT_TARGET = "/overview";

export default useLogOut;
